import React from "react";
import { Row, Col } from "antd";
import { Pie } from "@ant-design/plots";
import styled from "@emotion/styled";
import { get } from "lodash";
import moment from "moment";

const StyledChartContainer = styled.div`
  border-radius: 3px;
  padding: 10px;
  margin-bottom: 15px;
  box-shadow: 0px 4px 27px 0px #00000017;

  .report-title {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    font-size: 0.8rem;
    padding: 3px 10px;
    text-transform: uppercase;
  }

  .cf-text {
    font-size: 12px;
    color: #2563eb;
    font-weight: 500;
  }

  .legends {
    padding-top: 2rem;
    padding-left: 5px;
    text-align: left;
  }

  .legend-row {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    justify-content: space-between;
  }

  .legend-left {
    display: flex;
    align-items: center;
  }
`;

const StyledColorBox = styled.span`
  ${({ color }) => color && `background: ${color};`}
  border-radius: 4px;
  width: 12px;
  height: 12px;
  margin-right: 8px;
  display: inline-block;
`;

function LeaveTrackerChart({
  title,
  data = [],
  carryForward = 0,
}) {
  // 🔒 SAFE extraction
  const availableItem = data.find((d) => d.type === "available") || {};
  const consumedItem = data.find((d) => d.type === "consumed") || {};

  const available = Number(availableItem.value ?? 0);
  const consumed = Number(consumedItem.value ?? 0);

  // 🔒 Chart config (order-safe)
  const config = {
    width: 120,
    height: 120,
    appendPadding: 6,
    data: [
      { ...availableItem, value: available },
      { ...consumedItem, value: consumed },
    ],
    angleField: "value",
    colorField: "type",
    color: [availableItem.color, consumedItem.color],
    radius: 1,
    innerRadius: 0.8,
    legend: false,
    tooltip: false,
    label: false,
    statistic: {
      title: false,
      content: {
        style: { fontSize: 13 },
        content: `${available}`, // ✅ center shows available
      },
    },
  };

  return (
    <StyledChartContainer>
      <Row>
        <Col span={24} className="report-title">
          <span>
            {title} - {moment().format("YYYY")}
          </span>

          <span className="cf-text">CF: {carryForward} Days</span>
        </Col>

        <Col span={12}>
          <Pie {...config} />
        </Col>

        <Col span={12} className="legends">
          {/* ✅ Available FIRST */}
          <div className="legend-row">
            <div className="legend-left">
              <StyledColorBox color={availableItem.color} />
              <span>Available</span>
            </div>
            <strong>{available}</strong>
          </div>

          {/* ✅ Consumed SECOND */}
          <div className="legend-row">
            <div className="legend-left">
              <StyledColorBox color={consumedItem.color} />
              <span>Consumed</span>
            </div>
            <strong>{consumed}</strong>
          </div>
        </Col>
      </Row>
    </StyledChartContainer>
  );
}

export default LeaveTrackerChart;